//ionic project requirement to bootstrap the app
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { MyApp } from "./app.component";

import { IonicStorageModule } from "@ionic/storage";
import { ApiService } from "@providers/api.services";
import { AuthService } from "@providers/auth.service";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { Device } from '@ionic-native/device';
import { FCM } from '@ionic-native/fcm';
import { KeepService } from "@providers/keep.service";
import { FilterService } from "@providers/filter.services";
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
@NgModule({
  declarations: [MyApp],
  imports: [
    HttpClientModule,
    BrowserModule,
    IonicStorageModule.forRoot({
      name: "__web_gtc_admin",
      driverOrder: ["indexeddb", "sqlite", "websql"],
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    IonicModule.forRoot(
      MyApp,
      {
        preloadModules: false,
        mode: "md",
      },
    ),
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    FilterService,
    KeepService,
    Device,
    ApiService,
    AuthService,
    StatusBar,
    SplashScreen,
    FCM,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ],
  exports: [],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts